import { Component } from '@angular/core';

import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService, PlatformService,
    TempPassObject, ValidationService,
    DeviceInfo
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the RecoverPasswordComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'recover-password',
  templateUrl: 'recover-password.html'
})
export class RecoverPasswordComponent extends BaseComponent {

    foundAccount: boolean = false;
    accountExists: boolean = false;
    tempPassSent: boolean = false;
    userId: string;
    tempPasswordEmail: TempPassObject = new TempPassObject();

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected platformService: PlatformService,
        protected popoverCtrl: PopoverController,
        protected navParams: NavParams,
        protected validationService: ValidationService,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "RecoverPasswordComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.tempPasswordEmail.Email = this.navParams.get('email');
    }

    CheckAccount() {
        this.tokenService.ensureValidToken().then((token) => {
            this.userId = this.tempPasswordEmail.Email;
            if (this.validationService.emailIsValid(this.userId)) {
                this.accountService.TRLogin(this.userId, "", true, {})
                    .takeUntil(this.componentDestroyed$)
                    .finally(() => {
                        this.foundAccount = true;
                    })
                    .subscribe((user) => {
                        this.loggingService.debug(user);
                        this.accountExists = user ? true : false;

                        if (this.accountExists) {
                            this.sendTemporaryPassword();
                        } else {
                            this.showNotification('No account was found with this email address.', undefined, undefined, "error");
                        }
                    },
                        (error) => {
                            this.handleError(error);
                        });
            } else {
                this.showNotification('Please provide a valid email address.', undefined, undefined, "warning");
            }
        });
    }

    sendTemporaryPassword() {
        if (this.tempPasswordEmail && this.tempPasswordEmail.Email && this.tempPasswordEmail.Email.length > 0) {
            this.accountService.sendTempPassword(this.tempPasswordEmail)
                .subscribe((result) => {
                    if (!result) {
                        this.showNotification("Failed to send temporary password to target email.", undefined, undefined, "warning");
                    } else {
                        this.tempPassSent = true;
                        this.showNotification("Temporary password sent to target email", undefined, undefined, "success");
                    }
                },
                    (error) => {
                        this.handleError(error);
                    }
                );
        }
    }

    Cancel() {
        this.viewCtrl.dismiss({ redirectToLogin: this.tempPassSent, email: this.tempPasswordEmail.Email });
    }
}



// WEBPACK FOOTER //
// ./src/components/recover-password/recover-password.ts